// extracted by mini-css-extract-plugin
module.exports = {"copyModule":"copy-module-module--copyModule--1cVsI","headline":"copy-module-module--headline--Xe7UD","copy":"copy-module-module--copy--7YJ0d"};